<template>
  <el-dialog title="选择商品" v-model="visible" width="1480px">
    <page-request ref="table" :url="goodsType==1?'/api/mgr/shop/goods/list':'/api/mgr/shop/business/goods/list'"
                  :table-header="tableHeader" :expend="expend" :prop="{enables:1,goodsType:goodsType}" :op-width="120" >
          <template #op="scope">
            <b-button @click="doClick(scope.row)">选择</b-button>
          </template>
    </page-request>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="visible=false">关闭</el-button>
          </span>
    </template>
  </el-dialog>
</template>

<script>

import TButton from "@/components/el/t-button.vue";
import TTable from "@/components/el/t-table.vue";
import PageRequest from "@/components/base/page-request.vue";
import BButton from "@/components/el/b-button.vue";

export default {
  name: "goods-click-all",
  components: {BButton, PageRequest, TTable, TButton},
  data() {
    return {
      visible:false,
      tableData:[],
      goodsType:0,
      tableHeader:[
        {type: "goodShop", label: "商品",minWidth:300},
        {label: "价格",renderDraw:row=>{
            let content = "";
            if(row.storeGoodsType===1 ){
              content = "租赁价格:￥"+row.marketPrice+"元";
            }else if(row.storeGoodsType===2){
              content = "出售价格:￥"+row.salesPrice+"元<br/>"+"租赁价格:￥"+row.marketPrice+"元"
            }else{
              content = "出售价格:￥"+row.salesPrice+"元";
            }
            return content + (row.isAttribute?"起":"");
          },width:220},
        {prop: "inventory", label: "库存",width:100,renderDraw:row=>{
          return row.inventory + (row.marketInventory||0);
          }},
        {label: "状态",renderDraw:row=>{
            if(this.goodsType==0){
              return row.goodsEnables==0?"下架":"在售";
            }else{
              if(row.goodsEnables==0){
                return "下架";
              }
              return row.enables?"在售":"下架";
            }
          },width: 100},
        {prop: "updateTime", label: "更新时间",width:160},
        {label: "创建时间",width:160,renderDraw:row=> row.goodsCreateTime || row.createTime},
      ],
      expend: [
        {label: "商品名称", prop: "name"},
        {label: "商品ID", prop: "codes"},
        {label: "创建时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"}
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    doClick(row){
      this.$emit('change',row,this.goodsType);
      this.visible = false;
    },
    open(goodsType){
      this.goodsType = goodsType;
      this.visible = true;
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
